import { REFERRAL_STATS, SEND_REFERRALS } from '@/constants/urls';
import { getCoreApi } from '@/utility/getCoreApi';

import apiRequest from './apiRequest';
import {
  IFullUserProps,
  IRefererInfo,
  IReferralStatsProps,
  IReferredProps,
  ISendReferralsProps,
} from './types/referral/referral';

export const getReferralStats = (token?: string) => {
  return apiRequest<IReferralStatsProps>(
    {
      url: `${getCoreApi()}${REFERRAL_STATS}`,
      method: 'GET',
    },
    true,
    false,
    token,
  );
};

export const getFullUserInfo = async (userID: number, token?: string) => {
  return await apiRequest<IFullUserProps>(
    {
      url: `${getCoreApi()}/users/${userID}`,
      method: 'GET',
    },
    true,
    false,
    token,
  );
};

export const sendReferrals = async (data: ISendReferralsProps, token?: string) => {
  return await apiRequest<IReferredProps>(
    {
      url: `${getCoreApi()}${SEND_REFERRALS}`,
      method: 'POST',
      data,
    },
    true,
    false,
    token,
  );
};

export const getReferrerInfo = async (referralCode: string, token?: string) => {
  return apiRequest<IRefererInfo>(
    {
      url: `${getCoreApi()}/referrals/${referralCode}/info`,
      method: 'GET',
    },
    true,
    false,
    token,
  );
};
